/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { Dispatch } from 'react';
import { IListSportReturn } from '../interfaces/sport';
import { getAllSports } from '../services/sport';
import { listSportActions } from './definition';

/*function sportError(e: string, commune: any) {
    return {
        type: listSportActions.LIST_SPORT_ERROR,
        error: e,
        data: commune,
    };
}*/

// Reducers of Single Sport
/*function sportIsLoading() {
    return {
        type: listSportActions.LIST_SPORT_IS_LOADING,
    };
}*/

const sportListReset = () => {
    return {
        type: listSportActions.LIST_SPORT_RESET,
    };
};

// Recuders of Sport Collection
function sportIsLoadingList() {
    return {
        type: listSportActions.LIST_SPORT_IS_LOADING,
    };
}

function sportErrorList(e: string) {
    return {
        type: listSportActions.LIST_SPORT_ERROR,
        error: e,
    };
}

function sportSetList(sports: any) {
    return {
        type: listSportActions.LIST_SPORT,
        data: sports,
    };
}

/**
 * Reducer to rest a sports
 * @param values Data to reset sports
 */
export const resetStateSport = () => {
    return async (dispatch: Dispatch<any>): Promise<void> => {
        dispatch(sportListReset());
    };
};

/**
 * Reducer to rest a sports
 * @param values Data to reset sports
 */
export const resetSportReset = () => {
    return async (dispatch: Dispatch<any>): Promise<void> => {
        dispatch(sportListReset());
    };
};

/**
 * Reducer to reset Sports
 * @param values Values to reset sports
 */
export const resetSport = () => {
    return async (dispatch: Dispatch<any>): Promise<void> => {
        dispatch(sportListReset());
    };
};

// List

/**
 * Reducer to get all the sports
 */
export const fetchListSports = () => {
    return async (dispatch: Dispatch<any>): Promise<void> => {
        dispatch(sportIsLoadingList());
        await getAllSports()
            .then((response: IListSportReturn) => {
                //console.log({ response })
                if (response.statusCode === 'SPORTS_LISTED') {
                    dispatch(sportSetList(response.data));
                } else {
                    dispatch(sportErrorList(response.message));
                }
            })
            .catch((error) => {
                dispatch(sportErrorList(error));
            });
    };
};
